import { Module } from "vuex";
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import router from "@/router";
import { defaultFacilityValues } from "@/consts/defaultFacilityValues";
import { createFacilityFromBuddy } from "@/utils/buddyFacilityCreatorUtils";
import { SupeAdminAccessLevel } from "@/enums/StaffAccessLevels";
import { serializer } from "@/api/shared/serializer";
import { trimStringFields } from '@/utils/stringFormat';

const buddyModule: Module<any, any> = {
  namespaced: false,
  state: {
    currentRegions: null,
    selectedBuddyFacility: null,
    selectedBuddyFacilityUsers: [],
  },

  mutations: {
    setCurrentRegions(state: any, payload: []) {
      state.currentRegions = payload;
    },
    setSelectedBuddyFacility(state: any, payload: []) {
      state.selectedBuddyFacility = payload;
    },
    setSelectedFacilityUsers(state: any, payload: []) {
      state.selectedBuddyFacilityUsers = payload;
    },
    clearState(state: any) {
      state.currentRegions = null
      state.selectedBuddyFacility = null
      state.selectedBuddyFacilityUsers = [];
    },
  },

  actions: {
    async getBuddyFacilities({ commit }) {
      const facilities = firebase.firestore().collection("facility");
      return await facilities.get().then((querySnapshot) => {
        const facilitiesList: Array<any> = [];
        querySnapshot.docs.forEach((x) => {
          const thisRes = x.data();
          thisRes.id = x.id;
          facilitiesList.push(thisRes);
        });
        return facilitiesList
      });
    },

    async getBuddyOrgs({ commit }) {
      const organisations = firebase.firestore().collection("organisations");
      return await organisations.get().then((querySnapshot) => {
        const buddyOrganisationsList: Array<any> = [];
        querySnapshot.docs.forEach((x) => {
          const thisRes = x.data();
          thisRes.id = x.id;
          buddyOrganisationsList.push(thisRes);
        });
        return buddyOrganisationsList
      });
    },

    async getBuddyFacility({ commit }, id) {
      const fref = await firebase.firestore().collection("facility").doc(id).get();
      const careApiKey = await firebase.firestore().collection("facility").doc(id).collection("sensitive-data").where('type', '==', 'careApi').get()
      const facility = fref.data();
      console.log(careApiKey)
      facility.careApiKey = careApiKey?.docs[0]?.data()?.apiKey ?? '';
      facility.id = id;
      facility.dateFormat = facility.dateFormat || defaultFacilityValues.dateFormat
      facility.timeFormat = facility.timeFormat || defaultFacilityValues.timeFormat
      facility.languageIso = facility.languageIso || defaultFacilityValues.locale

      commit("setSelectedBuddyFacility", facility);
      return facility
    },

    async updateBuddyFacility({ dispatch, commit }, facility) {
      console.log("updating facility")
      try {
           const careApiKey = facility.careApiKey;
          facility.careApiKey = null;
          delete facility.dateTimeCreated
          await firebase
            .firestore()
            .collection("facility")
            .doc(facility.id)
            .update(facility)
            .then(async (Snap) =>  {
              await firebase
                .firestore()
                .collection("facility")
                .doc(facility.id)
                .collection("sensitive-data")
                .where('type', '==', 'careApi').get()
                .then(async (careapidoc) => {
                  if(careapidoc.docs[0]){
                    await firebase
                    .firestore()
                    .collection("facility")
                    .doc(facility.id)
                    .collection("sensitive-data")
                    .doc(careapidoc.docs[0].id)
                    .update({
                      apiKey: careApiKey
                    })
                  }
                });
        });
      } catch (error) {
        throw new Error('Error updating facility: ' + error.message);
      }
    },

    async getBuddyFacilityUsers({ commit }, { id, orgId }) {

      const users = firebase.firestore().collection("users").where("orgId", "==", orgId);
      await users.get().then((querySnapshot) => {
        const usersList: Array<any> = [];
        querySnapshot.docs.forEach((x) => {

          
          const thisUsers = x.data();
          thisUsers.id = x.id;
          if (thisUsers.facilityId == id) {
            usersList.push(thisUsers);
          }
        });
        commit("setSelectedFacilityUsers", usersList);
      });
    },

    async getBuddyUsers({ commit }, id) {
      const users = firebase
        .firestore()
        .collection("users")
      await users.get().then((querySnapshot) => {
        const listUsers: Array<any> = [];

        querySnapshot.docs.forEach((x) => {
          const thisUser = x.data();
          thisUser.id = x.id;
          listUsers.push(thisUser);
        });
        commit("setUsers", listUsers);
      });
    },

    async getBuddyUser({ commit }, id) {
      const user = firebase
        .firestore()
        .collection("users")
        .doc(id);
      await user.get().then((querySnapshot) => {
        const currentUser = querySnapshot.data();
        if (currentUser != null) {
          currentUser.id = querySnapshot.id;
          commit("setUser", currentUser);
        }
      });
    },

    async getMCareGenericAPIData({ commit, state }, facilityId: string) {

      if(this.state.authModule.user.accessLevel !== SupeAdminAccessLevel) return

      return await firebase
        .firestore()
        .collection("facility")
        .doc(facilityId)
        .collection("sensitive-data")
        .where('type', '==', 'genericApi')
        .limit(1)
        .get()
        .then((querySnapshot) => {
          const result: any = serializer.querySnapshotToDocuments(querySnapshot);
          return result[0];
        })
    },

    async updateMCareGenericAPIData({ commit, dispatch, state }, data: any) {

      if(this.state.authModule.user.accessLevel !== SupeAdminAccessLevel) return

      if (!data || !data.facilityId || !data.updates) {
        throw new Error('data is not valid');
      }

      const genericApiType = 'genericApi'

      const collectionRef = firebase
        .firestore()
        .collection("facility")
        .doc(data.facilityId)
        .collection("sensitive-data");

      let docRef;

      if (data.id) {
        docRef = collectionRef.doc(data.id);
        await docRef.set(data.updates, { merge: true });
      } else {
        // Check if a genericApi doc already exists before creating a new one
        const existing = await collectionRef.where('type', '==', 'genericApi').limit(1).get();
        if (!existing.empty) {
          docRef = existing.docs[0].ref;
          await docRef.set(data.updates, { merge: true });
          data.id = existing.docs[0].id;
        } else {
          data.updates.type = genericApiType;
          docRef = collectionRef.doc();
          data.id = docRef.id;
          await docRef.set(data.updates);
        }
      }

      return await dispatch('getMCareGenericAPIData', data.facilityId);
    },

    async getInsertCareNoteAPIData({ commit, state }, facilityId: string) {

      if(this.state.authModule.user.accessLevel !== SupeAdminAccessLevel) return

      return await firebase
        .firestore()
        .collection("facility")
        .doc(facilityId)
        .collection("sensitive-data")
        .where('type', '==', 'ResHubInsertCareNote')
        .limit(1)
        .get()
        .then((querySnapshot) => {
          const result: any = serializer.querySnapshotToDocuments(querySnapshot);
          return result[0] || { isEnabled: false, resHubApiKey: '' };
        })
    },

    async updateInsertCareNoteAPIData({ commit, dispatch, state }, data: any) {

      if(this.state.authModule.user.accessLevel !== SupeAdminAccessLevel) return

      if (!data || !data.facilityId || !data.updates) {
        throw new Error('data is not valid');
      }

      const insertCareNoteType = 'ResHubInsertCareNote'

      // Ensure isEnabled is explicitly a boolean
      data.updates.isEnabled = data.updates.isEnabled === true;

      const collectionRef = firebase
        .firestore()
        .collection("facility")
        .doc(data.facilityId)
        .collection("sensitive-data");

      let docRef;

      if (data.id) {
        docRef = collectionRef.doc(data.id);
        const docSnap = await docRef.get();

        if (docSnap.exists) {
          await docRef.update(data.updates);
        } else {
          data.updates.type = insertCareNoteType;
          await docRef.set(data.updates);
        }
      } else {
        // Check if a ResHubInsertCareNote doc already exists before creating a new one
        const existing = await collectionRef.where('type', '==', 'ResHubInsertCareNote').limit(1).get();
        if (!existing.empty) {
          docRef = existing.docs[0].ref;
          await docRef.update(data.updates);
          data.id = existing.docs[0].id;
        } else {
          data.updates.type = insertCareNoteType;
          docRef = collectionRef.doc();
          data.id = docRef.id;
          await docRef.set(data.updates);
        }
      }

      return await dispatch('getInsertCareNoteAPIData', data.facilityId);
    },

    async createNewBuddyFacilityUser({ dispatch, commit }, { user, orgId }) {
      user.options = {
        webNotifications: {
          serviceRequestCreated: false,
          serviceRequestCompleted: false,
          unattendedEventEnded: false,
          maintenanceRequestCreated: false,
          maintenanceRequestWarning: false,
          deviceAssigned: false,
          deviceUnassigned: false,
          visitToResidentCreated: false,
          bookingsAndOrdersComment: false,
          messagesFromFamily: true,
          updatesADT: false,
        },
        emailNotifications: {
          serviceRequestCreated: false,
          serviceRequestCompleted: false,
          unattendedEventEnded: false,
          maintenanceRequestCreated: false,
          maintenanceRequestOverdue: false,
          maintenanceRequestWarning: false,
          deviceAssigned: false,
          deviceUnassigned: false,
          visitToResidentCreated: false,
          bookingsAndOrdersComment: false,
          lifestyleEventsReport: false,
          messagesFromFamily: true,
          updatesADT: false
        }
      }
      trimStringFields(user);
      await firebase.firestore().collection("users").add(user).then((a) => { dispatch("getBuddyFacilityUsers", { facilityId: user.facilityId, orgId: user.orgId }) });
    },

    async createBuddyFacility({ dispatch, commit }, data) {
          const fid = await createFacilityFromBuddy(data)
      
          if (fid) {
            dispatch('getOrgUsers', data.orgId);
            dispatch('getFacilitiesForOrg', data.orgId);
            dispatch('getFacilityEmailTemplates', fid);
            await dispatch("getBuddyFacility", fid)
            router.push("/buddy/facilities/" + fid.toString());
          }
    },
     
    async createBuddyOrg({ dispatch, commit }, { name, refId }) {
      const settings: any = {
        name: name,
        baseUrl: ''
      }

      if(refId && refId.length) {
        settings.refId = refId;
      }

      await firebase.firestore().collection("organisations").add(settings).then((org) => {
        firebase.firestore().collection("regions").doc(org.id).set({ name: 'Default', orgId: org.id });
      })
    },

    async getBuddyRegions({ commit }, orgId) {

      const regions = firebase
        .firestore()
        .collection("regions")
        .where("orgId", "==", orgId)

      await regions.get().then((querySnapshot) => {
        const listRegions: Array<any> = [];

        querySnapshot.docs.forEach((x) => {
          const thisregion = x.data();
          thisregion.id = x.id;
          listRegions.push(thisregion);
        });
        commit("setCurrentRegions", listRegions);
      });
    },

    async clearBuddyState({ commit }) {
      commit("clearState");
    },
  },
};
export default buddyModule;